import EmailButton from './emailButton.view';

export default EmailButton;
